module.exports = __webpack_public_path__ + "static/onelogin-abf39227232a665fa552332e3dae1174.svg";